import React from 'react'
import './index.css'
import Flex from 'components/Flex'
import H2 from 'components/H2'
import ButtonLink from 'components/ButtonLink'
import { ROUTE_PATH } from 'modules/route/constants'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import Span from 'components/Span'
import FlexColumn from 'components/FlexColumn'
import View from 'components/View'
import Image from 'components/Image'
import setShouldScrollToReferAFriendAfterSignInUtil from 'pages/Squad/utils/set-scroll-to-refer-a-friend-after-sign-in'

const IMAGE_SRC = 'https://cdn.shopify.com/s/files/1/0569/9957/5718/files/Rating_cardx_44528d50-a6d2-4e4e-8b9b-e18009f17cc6.png?v=1696534956'
const JOIN_NOW = 'Join now'
const TITLE = 'How it works?'
const STEPS = [
  { description: 'Invite your friends to join your squad' },
  { description: 'Try samples and rate them' },
  { description: 'Share ratings and see what your squad liked' }
]

const ANALYTICS_EVENT = {
  SQUAD_EMPTY_HOW_IT_WORKS_JOIN_NOW: 'SQUAD_EMPTY_HOW_IT_WORKS_JOIN_NOW'
}

export default function SquadPageEmptyHowItWorks () {
  const debugProps = {}
  logUtil('SquadPageEmptyHowItWorks').debug('[start] debugProps=', debugProps)
  const handleJoinNow = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_EMPTY_HOW_IT_WORKS_JOIN_NOW)
    setShouldScrollToReferAFriendAfterSignInUtil()
  }

  return (
    <Flex className='squad-empty-how-it-works'>
      <View className='squad-empty-how-it-works-image'>
        <Image src={IMAGE_SRC} alt='rating card' />
      </View>
      <FlexColumn className='squad-empty-how-it-works-content'>
        <H2>{TITLE}</H2>
        <View className='squad-empty-how-it-works-steps'>
          {
            STEPS.map((step, index) => {
              return (
                <ul className='squad-empty-how-it-works-step' key={step.description}>
                  <li>
                    <Flex>
                      <Span className='squad-empty-how-it-works-step-index'>{index + 1}</Span>
                      <Span className='squad-empty-how-it-works-step-description'>{step.description}</Span>
                    </Flex>
                  </li>
                </ul>
              )
            })
          }
        </View>
        <ButtonLink
          onClick={handleJoinNow}
          href={ROUTE_PATH.REGISTER}
          className='squad-empty-how-it-works-join-now'
        >
          {JOIN_NOW}
        </ButtonLink>
      </FlexColumn>
    </Flex>
  )
}
